// extracted by mini-css-extract-plugin
export default {"login":"Login_login__yplOB","login__logo":"Login_login__logo__ZqTai","login__title":"Login_login__title__4OD78"};